<template>
    <editor-field-frame :label="props.label" :hint="props.hint" :control-id="controlId">
        <template #default="{controlId: id, hintId}">
            <v-select v-model="value"
                      v-bind="controlProps"
                      :id="id"
                      :aria-describedby="hintId" />
        </template>
    </editor-field-frame>
</template>

<script setup>
import {computed} from "vue";
import EditorFieldFrame from "./EditorFieldFrame.vue";
import {
    mandatory_props,
    useEditorField,
    editorControlProps,
    editorControlId,
} from "../../utils/editorConfigFieldHelpers";

const props = defineProps(mandatory_props);
const {value, jsonPath} = useEditorField(props);

/**
 * Die Auswahlwerte liegen historisch in vuetify_config.items - das ist eine
 * funktionale Angabe und in editorControlProps() ausdrücklich erlaubt.
 */
const controlProps = computed(() => editorControlProps(props.vuetify_config));
const controlId = computed(() => editorControlId('select', jsonPath.value));
</script>
